export default __webpack_public_path__ + "static/homeschooler-b7eb7c10d7ab7d0493099ed30193d205.jpg";